import { AnimatePresence, motion } from 'motion/react';
import React, { useState } from 'react'
import NestedMenu from '../NestedMenu';



const MobileNavItem = ({ item, labels }) => {
	const [isOpen, setIsOpen] = useState(false);
	const handleToggle = () => {
		setIsOpen((o) => !o);
	}
	
	return (
		<li className={`nav-item ${isOpen ? 'is-open' : ''}`}>
			<button className="nav-item__trigger" onClick={handleToggle}>
				{item.title}
			</button>
			<span style={{rotate: isOpen ? '180deg' : '0deg'}} className="nav-item__trigger-icon"></span>
			<AnimatePresence>

				{isOpen && (
					<motion.div  initial={{ height: 0, opacity: 0 }}
						animate={{ height: "auto", opacity: 1 }}
						exit={{ height: 0, opacity: 0 }}
						transition={{ duration: 0.25, ease: "easeInOut" }}
						style={{ overflow: "hidden" }}>
						<NestedMenu items={item.children} labels={labels} />
					</motion.div>
				)}
			</AnimatePresence>
		</li>
	)
}

export default MobileNavItem